import { Directive, HostListener } from '@angular/core'
import { BaseTooltipDirective } from './base-tooltip.directive'

@Directive({
  selector: '[santaTooltip]'
})
export class TooltipDirective extends BaseTooltipDirective {
  @HostListener('mouseenter')
  public show(): void {
    if (!this.controlledByParent && !this.disableTooltip) {
      this.showTooltip()
    }
  }

  @HostListener('mouseleave')
  @HostListener('click')
  public hide(): void {
    if (!this.controlledByParent && !this.disableTooltip) {
      this.hideTooltip()
    }
  }
}
